import { QueryClient, UseMutationResult, useQueryClient, UseQueryResult } from "react-query";
import ConsoleApi from "apps/console/enums/consoleApi";
import { useEntity } from "apps/console/context/entity";
import { getRegDetailsKey } from "shared/context/regDetail/dataloader";
import { useCopies } from "shared/hooks/useCopies";
import { ApiEventResponse } from "shared/types/ApiEventResponse";
import { ApiRegistrationEvent } from "shared/types/ApiRegistration";
import { successToast } from "shared/utils/toastNotification";
import { getApiQueryKey, useGetApiData, usePostApiData } from "shared/datalayer";

function getEventDetailsKey(id?: string) {
  return getApiQueryKey(ConsoleApi.GET_EVENT_BY_ID, { pathParams: { id } });
}

export function useGetEvent({ id }: { id?: string }): UseQueryResult<ApiEventResponse> {
  return useGetApiData<ApiEventResponse>(
    ConsoleApi.GET_EVENT_BY_ID,
    {
      pathParams: { id }
    },
    {
      enabled: Boolean(id)
    }
  );
}

export function useUpdateEvent(): UseMutationResult<ApiEventResponse> {
  const copies = useCopies();
  const queryClient = useQueryClient();
  const { registrationId } = useEntity();

  return usePostApiData<ApiEventResponse, any>(ConsoleApi.UPDATE_EVENT, {
    onSuccess: data => {
      successToast(copies.get("event.update.success.msg"));
      updateEventInRegDetails({ data, queryClient, registrationId });
      queryClient.setQueryData(getEventDetailsKey(data?.id), (prev: any) => ({ ...prev, ...data }));
    }
  });
}

export function useCreateEvent(): UseMutationResult<ApiEventResponse> {
  const copies = useCopies();

  return usePostApiData<ApiEventResponse, any>(ConsoleApi.CREATE_EVENT, {
    onSuccess: () => {
      successToast(copies.get("event.create.success.msg"));
    }
  });
}

export function refetchEventDetails({ queryClient, eventId }: { queryClient: QueryClient; eventId?: string }) {
  queryClient.refetchQueries(getEventDetailsKey(eventId));
}

export function updateEventInRegDetails({
  data,
  queryClient,
  registrationId
}: {
  registrationId: string;
  queryClient: QueryClient;
  data: ApiEventResponse;
}) {
  queryClient.setQueryData(getRegDetailsKey({ registrationId }).key, (reg: any) => {
    return {
      ...reg,
      events: reg.events.map((event: ApiRegistrationEvent) =>
        event.id === data.id ? { ...event, name: data.name, startDate: data.startDate } : event
      )
    };
  });
}
